(() => {
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (!reduce) {
    document.documentElement.classList.add("fh-motion");

    const main = document.getElementById("MainContent");
    const sections = main ? [...main.querySelectorAll(":scope > .shopify-section")] : [];

    const markIn = (el) => el.classList.add("fh-in");

    if (!("IntersectionObserver" in window)) {
      sections.forEach(markIn);
    } else {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            markIn(entry.target);
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.16, rootMargin: "0px 0px -40px 0px" }
      );

      sections.forEach((section) => {
        section.classList.add("fh-reveal");
        observer.observe(section);
      });
    }
  }

  document.addEventListener("click", async (event) => {
    const button = event.target.closest("[data-fh-share]");
    if (!button) return;
    event.preventDefault();
    const url = button.dataset.url || window.location.href;
    const title = button.dataset.title || document.title;
      if (navigator.share && window.matchMedia("(max-width: 749px)").matches) {
        try {
          await navigator.share({ title, url });
        } catch (error) {
          if (error && error.name === "AbortError") return;
        }
        return;
      }
      if (navigator.share && !window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
        try {
          await navigator.share({ title, url });
          return;
        } catch (error) {
          if (error && error.name === "AbortError") return;
        }
      }
      try {
        await navigator.clipboard.writeText(url);
      } catch (error) {
        return;
      }
      const label = button.querySelector("[data-fh-share-label]");
      if (!label) return;
      const previous = label.textContent;
      button.classList.add("is-copied");
      label.textContent = "Link copied";
      window.setTimeout(() => {
        button.classList.remove("is-copied");
        label.textContent = previous;
      }, 2000);
  });

  document.querySelectorAll(".fh-footer__acc > button").forEach((button) => {
    button.addEventListener("click", () => {
      const group = button.parentElement;
      const open = group.classList.toggle("is-open");
      button.setAttribute("aria-expanded", open ? "true" : "false");
    });
  });

  document.querySelectorAll("[data-fh-all-filters]").forEach((button) => {
    button.addEventListener("click", () => {
      const opener =
        document.querySelector(".facets-toggle") ||
        document.querySelector(".facets__summary") ||
        document.querySelector("facets-form summary");
      opener?.click();
    });
  });

  document.querySelectorAll("[data-fh-filter]").forEach((button) => {
    button.addEventListener("click", () => {
      const name = button.dataset.fhFilter.toLowerCase();
      const aliases = name === "colour" ? ["colour", "color"] : [name];
      const summary = [...document.querySelectorAll(".facets__summary, .facets__label")].find((el) => {
        const text = el.textContent.toLowerCase();
        return aliases.some((alias) => text.includes(alias));
      });
      if (summary) {
        summary.click();
        return;
      }
      document.querySelector(".facets-toggle")?.click();
    });
  });

  const arrivals = document.querySelector('[id$="__fh_arrivals"]');
  const slidesEl = arrivals?.querySelector("slideshow-slides");
  if (arrivals && slidesEl) {
    const slides = [...slidesEl.querySelectorAll(":scope > slideshow-slide, :scope > .resource-list__slide")];
    const perView = () => (window.innerWidth >= 750 ? 4 : 2);
    const pages = () => Math.max(1, Math.ceil(slides.length / perView()));
    const pager = document.createElement("div");
    pager.className = "fh-pager";
    arrivals.querySelector(".section-resource-list")?.append(pager);

    const paint = () => {
      const count = pages();
      const width = slidesEl.clientWidth || 1;
      const index = Math.min(count - 1, Math.round(slidesEl.scrollLeft / width));
      pager.replaceChildren(
        ...Array.from({ length: count }, (_, dotIndex) => {
          const dot = document.createElement("button");
          dot.type = "button";
          dot.className = "fh-pager__dot";
          dot.setAttribute("aria-label", `Page ${dotIndex + 1}`);
          if (dotIndex === index) dot.setAttribute("aria-current", "true");
          dot.addEventListener("click", () => {
            slidesEl.scrollTo({
              left: dotIndex * slidesEl.clientWidth,
              behavior: reduce ? "auto" : "smooth",
            });
          });
          return dot;
        })
      );
    };

    slidesEl.addEventListener("scroll", paint, { passive: true });
    window.addEventListener("resize", paint);
    paint();
  }
})();
